<script>
import SubNav from "./SubNav"
export default {
	components: {
		SubNav
	},
	props: ["tree"],
	data() {
		return {
			visible: false,
			main_menu: []
		}
	},
	mounted() {
		let main_menu = localStorage.getItem("main_menu")
		if (main_menu) {
			this.main_menu = JSON.parse(main_menu)
		} else {
			axios
				.get("/main_menu.json")
				.then(response => {
					this.main_menu = response.data.data
					localStorage.setItem(
						"main_menu",
						JSON.stringify(this.main_menu)
					)
				})
				.catch(e => {
					console.log(e)
				})
		}
	},
	computed: {
		topLevelLinks() {
			return this.main_menu.filter(item => {
				return !item.parent
			})
		},
		nestedStructure() {
			let nested = []
			this.topLevelLinks.forEach(top => {
				let children = []
				children = this.main_menu.filter(item => {
					return item.parent && item.parent == top.id
				})

				if (children.length > 0) {
					top.children = children
					top.hasChildren = true
					top.children.forEach(child => {
						let grandchildren = []
						grandchildren = this.main_menu.filter(grandchild => {
							return (
								grandchild.parent &&
								grandchild.parent == child.id
							)
						})

						if (grandchildren.length > 0) {
							child.children = grandchildren
							child.hasChildren = true
						} else {
							child.hasChildren = false
						}
					})
				} else {
					top.hasChildren = false
				}

				nested.push(top)
			})
			return nested
		}
	}
}
</script>

<template>
	<div class="px-6">
        <transition appear name="fade">
            <div
                class="flex flex-col md:flex-row"
                v-show="main_menu.length > 0"
            >
                <sub-nav 
					v-for="item in nestedStructure"
					:nav-item="item"					
					:key="item.id"
                />
            </div>
        </transition>
    </div>
</template>
